module.exports = __webpack_public_path__ + "static/media/ridgesPasses.90a82c97.svg";